import React from 'react';
import { Box, Tooltip } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TikTokIcon from '../../components/icons/TikTokIcon';
import YouTubeShortsIcon from '../../components/icons/YouTubeShortsIcon';
import type { SocialPlatform } from './utils';

const PLATFORM_ICON_COLOR: Record<SocialPlatform, string | undefined> = {
    facebook: '#1877F2',
    instagram: '#E4405F',
    tiktok: undefined,
    youtubeShorts: '#FF0000',
};

export function ExplorerPlatformIcon({
    platform,
    label,
    fontSize = 22,
    tooltip = false,
}: {
    platform: SocialPlatform;
    label: string;
    fontSize?: number;
    tooltip?: boolean;
}) {
    const color = PLATFORM_ICON_COLOR[platform];
    const sx = { fontSize, color, display: 'block' };
    const icon =
        platform === 'facebook' ? (
            <FacebookIcon sx={sx} />
        ) : platform === 'instagram' ? (
            <InstagramIcon sx={sx} />
        ) : platform === 'tiktok' ? (
            <TikTokIcon sx={sx} />
        ) : (
            <YouTubeShortsIcon sx={sx} />
        );

    const marked = (
        <Box
            component="span"
            role="img"
            aria-label={label}
            sx={{ display: 'inline-flex', alignItems: 'center', lineHeight: 0 }}
        >
            {icon}
        </Box>
    );

    if (!tooltip) return marked;
    return (
        <Tooltip title={label} arrow placement="top">
            {marked}
        </Tooltip>
    );
}

/** Icon plus platform name for selects and menu items. */
export function ExplorerPlatformOption({
    platform,
    label,
    fontSize = 18,
}: {
    platform: SocialPlatform;
    label: string;
    fontSize?: number;
}) {
    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                minWidth: 0,
                color: 'text.primary',
            }}
        >
            <ExplorerPlatformIcon platform={platform} label={label} fontSize={fontSize} />
            <Box
                component="span"
                sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    color: 'text.primary',
                }}
            >
                {label}
            </Box>
        </Box>
    );
}
